import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import _WidgetBaseSP from 'more/_WidgetBaseSP';

import domConstructTyped from 'dojo/dom-construct';
const domConstruct: any = domConstructTyped;
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';

import on from 'dojo/on';
import template from './Accordion.html?raw';
import query from 'dojo/query';
// NOTE (JS2TS): dropped dead dep dojo/dom-style (imported but unused in code/template). DOM-heavy: dojo/dom-construct aliased to any.

class Accordion extends compose(_WidgetBaseSP) {
    [key: string]: any;
    templateString: any = template;

    _entries: any = [];
    zebra = true;

    constructor() {
        super(...(arguments as unknown as []));
        this._entries = [];
    }

    _setEntriesAttr(entries: any) {
        this._entries = entries;
    }

    _getEntriesAttr() {
        return this._entries;
    }

    add(id: any, title: any, text: any, group: any) {
        this.addEntry(id, title, text, group);
    }

    addEntry(id: any, title: any, text: any, group: any) {
        this._entries.push({
            "id": id,
            "title": title,
            "text": text,
            "group": group
        });
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.createEntries();
    }

    clear() {
        domConstruct.empty(this.entriesContainer);
    }

    _onGroupTitleClick(groupTitle: any, groupNode: any) {
        if (domClass.contains(groupNode, "w3-hide")) {
            domClass.remove(groupNode, "w3-hide");

            var toggleIndicator = query(".toggleIndicator", groupTitle)[0];
            if (toggleIndicator) {
                domClass.add(toggleIndicator, "fa-chevron-up");
                domClass.remove(toggleIndicator, "fa-chevron-down");
            }
        }
        else {
            domClass.add(groupNode, "w3-hide");

            var toggleIndicator = query(".toggleIndicator", groupTitle)[0];
            if (toggleIndicator) {
                domClass.remove(toggleIndicator, "fa-chevron-up");
                domClass.add(toggleIndicator, "fa-chevron-down");
            }
        }

    }

    createEntries() {
        domConstruct.empty(this.entriesContainer);
        var target = this.entriesContainer;

        // get all groups
        var groups = [];
        for (var i = 0; i < this._entries.length; i++) {
            var group = this._entries[i].group;

            if (typeof (group) != "undefined") {
                if (groups.indexOf(group) == -1) {
                    groups.push(group);
                }
            }
        }

        var noGroupMode = false;

        if (groups.length == 0) {
            groups.push("");
            noGroupMode = true;
        }

        console.log("noGroupMode", noGroupMode, JSON.stringify(groups));


        for (var x = 0; x < groups.length; x++) {
            var group = groups[x];

            var groupTitle = domConstruct.create("div", {
                className: "flex_row_center accordionGroup" + ((noGroupMode === true) ? " w3-hide" : ""),
                //innerHTML: group,
                style: {

                }
            }, target);

            domConstruct.create("div", {
                "style": {
                    "flex": 1,
                    "whiteSpace": "break-spaces"
                },
                "innerHTML": group,
                //"className": noGroupMode === true ? "w3-hide" : ""
            }, groupTitle);

            domConstruct.create("div", {
                //"className": "w3-right",
                "innerHTML": '<i class="fa fa-chevron-down toggleIndicator" aria-hidden="true"></i>'
            }, groupTitle);

            var groupNode = domConstruct.create("div", {
                className: "flex_row_center" + ((noGroupMode === true)? "":" w3-hide"),
                style: {

                }
            }, target);

            on(groupTitle, "click", lang.hitch(this, this._onGroupTitleClick, groupTitle, groupNode));

            for (var i = 0; i < this._entries.length; i++) {
                var entry = this._entries[i];

                if (entry.group != group && noGroupMode === false) continue;

                var entryButton = domConstruct.create("div", {
                    className: "w3-button w3-block w3-left-align accordionbutton flex_row_center",
                    //innerHTML: entry.title,
                    style: {
                        backgroundColor: (i % 2 == 0 && this.zebra) ? "#f6f6f6" : " #FCFCFC",
                        borderRadius: "4px",
                        borderBottom: "1px solid #dddddd"
                    }
                }, groupNode);

                var textNode = domConstruct.create("div", {
                    //"className": "w3-left",
                    "style": {
                        "flex": 1,
                        "whiteSpace": "break-spaces"
                    },
                    "innerHTML": entry.title
                },
                    entryButton);

                var rightButton = domConstruct.create("div", {
                    //"className": "w3-right",
                    "innerHTML": '<i class="fa fa-chevron-down toggleIndicator" aria-hidden="true"></i>'
                },
                    entryButton);

                var entryNode = domConstruct.create("div", {
                    className: "w3-hide w3-container accordiontext"
                }, groupNode);

                //console.log("create entries - add", entry, typeof (entry.text));
                if (typeof (entry.text) == "string") {
                    domAttr.set(entryNode, "innerHTML", entry.text);
                } else {
                    domConstruct.place(entry.text, entryNode, "only");
                }

                on(entryButton, "click", lang.hitch(this, "_onClick_EntryNode", entryNode, entry, entryButton));
            }
        }
    }


    _onClick_EntryNode(entryNode: any, entry: any, entryButton: any, evt: any) {
        if (domClass.contains(entryNode, "w3-show")) {
            domClass.remove(entryNode, "w3-show");

            var toggleIndicator = query(".toggleIndicator", entryButton)[0];
            if (toggleIndicator) {
                domClass.add(toggleIndicator, "fa-chevron-down");
                domClass.remove(toggleIndicator, "fa-chevron-up");
            }

        } else {
            domClass.add(entryNode, "w3-show");

            var toggleIndicator = query(".toggleIndicator", entryButton)[0];
            if (toggleIndicator) {
                domClass.add(toggleIndicator, "fa-chevron-up");
                domClass.remove(toggleIndicator, "fa-chevron-down");
            }

            (this as any).emit("shown", entry, entryNode);
        }
    }

}
Accordion.prototype.declaredClass = 'more.Legacy.Controls.Accordion';

export default mdsWidget(Accordion);
